import React from "react";
import PropTypes from "prop-types";
import Svg from "react-svg-inline";
import styles from "./index.module.css";
import twitterIcon from "./twitterIcon.svg";
import linkedInIcon from "./linkedInIcon.svg";
import SharingConfig from "../../utils/sharingConfig";

export const ShareLinkedIn = ({ url, sourceUrl, summary, title }) => {
  const queryParams = {
    url,
    sourceUrl,
    title: title,
    summary: summary || "",
    source: SharingConfig.linkedInSource
  };
  const queryString = Object.keys(queryParams)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`)
    .join("&");

  return (
    <Share
      icon={linkedInIcon}
      url={`https://www.linkedin.com/shareArticle?${queryString}`}
    />
  );
};

ShareLinkedIn.propTypes = {
  image: PropTypes.string,
  url: PropTypes.string,
  sourceUrl: PropTypes.string,
  summary: PropTypes.string,
  title: PropTypes.string
};

export const ShareTwitter = ({ text }) => {
  const queryParams = {
    text,
    hashtags: SharingConfig.hashtags
  };
  const queryString = Object.keys(queryParams)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`)
    .join("&");
  return (
    <Share
      icon={twitterIcon}
      url={`https://twitter.com/intent/tweet?${queryString}`}
    />
  );
};

ShareTwitter.propTypes = {
  hashtags: PropTypes.string,
  text: PropTypes.string
};

const Share = ({ url, icon }) => {
  return (
    <a className={styles.root} href={url} target="_blank">
      <Svg className={styles.icon} svg={icon} />
    </a>
  );
};

Share.defaultProps = {
  type: "twitter"
};

Share.propTypes = {
  url: PropTypes.string,
  icon: PropTypes.string // an svg
};

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share/index.js